<template>
  <div id="tab-pre-plan-booking">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="1"
            :class="btnCopyDisabled ? 'not-click' : ''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="
              p => {
                command1 = p
                commandHandle(command1)
              }
            "
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="$t('SeaExport.CopyLinkPromissoryNote')"
              >{{ $t('SeaExport.CopyLinkPromissoryNote') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyLinkPublic')">{{
                $t('SeaExport.CopyLinkPublic')
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            no="2"
            style="margin-left: 5px"
            :class="btnInvitationDisabled ? 'not-click' : ''"
            split-button
            type="primary"
            @click="commandHandle(command2)"
            @command="
              p => {
                command2 = p
                commandHandle(command2)
              }
            "
          >
            {{ command2 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="$t('SeaExport.InviteSupplementaryLinkPromissoryNote')"
              >{{
                $t('SeaExport.InviteSupplementaryLinkPromissoryNote')
              }}</el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.InviteSupplementaryLinksPublic')"
              >{{
                $t('SeaExport.InviteSupplementaryLinksPublic')
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 舱单日志 -->
          <el-button
            no="3"
            style="margin-left: 5px"
            :disabled="isEdit"
            type="primary"
            @click="handleReceipt('sendLog')"
          >{{ $t('SeaExport.manifestQueryLog') }}</el-button>
          <el-button
            v-permission="['button_TabPreBooking_unLock']"
            no="4"
            style="margin-left: 5px"
            :disabled="tempUnLockDisabled"
            type="primary"
            @click="unLockManifestHandler"
          >{{ $t('SeaExport.manifestUnLockButton') }}</el-button>
          <el-upload
            :disabled="excelImportDisabled"
            :data="{ importType: (isSeaHouseChannel ? 1 : 0), jobUuid: job.uuid, mainifestInfoUuid: (job.masterFlag ? '' : manifestInfo.uuid ? manifestInfo.uuid : manifestInfo.importTempUuid ? manifestInfo.importTempUuid : '') }"
            :action="URL.seaExport.manifestImportExcel"
            :headers="{ sessionId: user.sessionId }"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            style="display: inline-block; margin-left: 5px;"
          >
            <el-button
              slot="trigger"
              :disabled="excelImportDisabled"
              type="primary"
            >{{ $t('SeaExport.ExcelImport') }}</el-button>
          </el-upload>
          <!-- 隐藏下载模版 代码撤回-->
          <el-dropdown
            no="command4"
            style="margin-left: 5px"
            split-button
            type="primary"
            @click="commandHandle(command4)"
            @command="
              p => {
                command4 = p
                commandHandle(command4)
              }
            "
          >
            {{ command4 }}
            <el-dropdown-menu slot="dropdown">
              <!--              <el-dropdown-item-->
              <!--                :command="$t('SeaExport.DownloadCWTemplate')"-->
              <!--              >{{-->
              <!--                $t('SeaExport.DownloadCWTemplate')-->
              <!--              }}</el-dropdown-item>-->
              <!--              <el-dropdown-item-->
              <!--                :command="$t('SeaExport.DownloadSeaHouseTemplate')"-->
              <!--              >{{-->
              <!--                $t('SeaExport.DownloadSeaHouseTemplate')-->
              <!--              }}</el-dropdown-item>-->
              <el-dropdown-item
                :command="$t('SeaExport.DownloadWseTemplate')"
              >{{
                $t('SeaExport.DownloadWseTemplate')
              }}</el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.DownloadWseTemplateSh')"
              >{{
                $t('SeaExport.DownloadWseTemplateSh')
              }}</el-dropdown-item>
              <el-dropdown-item
                :command="$t('SeaExport.ExportSinO56TemplateNb')"
              >{{ $t('SeaExport.ExportSinO56TemplateNb') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-if="isSeaHouseChannel || isWseChannel || isRongeTong"
            style="margin-left: 5px"
            type="primary"
            @click="showShipGenerations"
          >{{ $t('CargoMsg.Cargo_ViewShipGenerations') }}</el-button>
          <span
            style="margin-left: 10px"
          >{{ $t('SeaExport.manifestCfmStateLog')
          }}<span
            style="color:#7FA5DD;cursor:pointer;margin-left: 10px;margin-right: 10px;"
          >{{ cfmStateText }}</span>
          </span>
          <el-radio
            v-model="manifestType"
            no="5"
            :disabled="isEdit || !manifestInfo.uuid"
            :label="0"
          >{{ $t('SeaExport.PreShippingBill') }}</el-radio>
          <el-radio
            v-model="manifestType"
            no="6"
            :disabled="isEdit || !manifestInfo.uuid"
            :label="1"
          >{{ $t('SeaExport.CleanShipping') }}</el-radio>
          <el-radio
            v-model="manifestType"
            no="7"
            :disabled="isEdit || !manifestInfo.uuid"
            :label="2"
          >VGM</el-radio>
          <div style="display:inline-block">
            <el-menu
              text-color="#404144"
              active-text-color="#404144"
              mode="horizontal"
              class="el-menu-button el-button el-button--primary el-button--mini"
              :class="popMenuDisabled ? 'is-disabled' : ''"
              style="vertical-align: bottom;"
              @select="ediSendHandler"
            >
              <el-submenu index="index" :disabled="popMenuDisabled">
                <span slot="title" class="el-menu-btn-text">
                  {{ manifestType === 0 ? (isSeaHouseChannel || isWseChannel || isRongeTong)?$t('SeaExport.PreShippingBillPperation'):$t('SeaExport.PreShippingBill') : '' }}
                  {{ manifestType === 1 ? $t('SeaExport.CleanShipping') : '' }}
                  {{ manifestType === 2 ? 'VGM' : '' }}
                </span>
                <el-submenu v-show="manifestType === 0" :index="(isSeaHouseChannel || isWseChannel || isRongeTong) ? $t('SeaExport.send') : $t('SeaExport.Original')">
                  <template slot="title">{{ isSeaHouseChannel ? $t('SeaExport.send') : $t('SeaExport.Original') }}</template>
                  <el-menu-item :disabled="!openBoolean" index="API0">API</el-menu-item>
                  <el-menu-item index="FTP1" :disabled="isHZ">FTP</el-menu-item>
                </el-submenu>
                <el-submenu v-show="manifestType === 0" :index="(isSeaHouseChannel || isWseChannel || isRongeTong) ? $t('SeaExport.change') : $t('SeaExport.Correct')">
                  <template slot="title">{{ isSeaHouseChannel ? $t('SeaExport.change') : $t('SeaExport.Correct') }}</template>
                  <el-menu-item index="FTP0" :disabled="isHZ">FTP</el-menu-item>
                  <el-menu-item :disabled="!openBoolean || isHZ" index="API1">API</el-menu-item>
                </el-submenu>
                <el-submenu v-show="manifestType === 0" :index="(isSeaHouseChannel || isWseChannel || isRongeTong) ? $t('SeaExport.deleteSingle') : $t('SeaExport.Delete')">
                  <template slot="title">{{ isSeaHouseChannel ? $t('SeaExport.deleteSingle') : $t('SeaExport.Delete') }}</template>
                  <el-menu-item index="FTP2" :disabled="isHZ">FTP</el-menu-item>
                  <el-menu-item :disabled="!openBoolean || isHZ" index="API2">API</el-menu-item>
                </el-submenu>
                <el-submenu v-show="manifestType === 0 && isSeaHouseChannel && manifestInfo.seaHouseState === '23'" :index="isSeaHouseChannel ? $t('SeaExport.cancelBill') : $t('SeaExport.Delete')">
                  <template slot="title">{{ $t('SeaExport.cancelBill') }}</template>
                  <el-menu-item :disabled="!openBoolean" index="API3">API</el-menu-item>
                </el-submenu>

                <el-submenu v-show="manifestType === 1" :index="$t('SeaExport.Original')">
                  <template slot="title">{{ $t('SeaExport.Original') }}</template>
                  <el-menu-item :disabled="!openClearBoolean" index="API0">API</el-menu-item>
                  <el-menu-item index="FTP1">FTP</el-menu-item>
                </el-submenu>
                <el-menu-item v-show="manifestType === 1" :index="$t('SeaExport.Correct')">
                  {{ $t('SeaExport.Correct') }}
                </el-menu-item>

                <el-submenu v-show="manifestType === 2" :index="$t('SeaExport.Original')">
                  <template slot="title">{{ $t('SeaExport.Original') }}</template>
                  <el-menu-item :disabled="!openVGMBoolean" index="API0">API</el-menu-item>
                  <el-menu-item index="FTP0">FTP</el-menu-item>
                </el-submenu>
                <el-submenu v-show="manifestType === 2" :index="$t('SeaExport.Correct')">
                  <template slot="title">{{ $t('SeaExport.Correct') }}</template>
                  <el-menu-item index="FTP1">FTP</el-menu-item>
                  <el-menu-item :disabled="!openVGMBoolean" index="API1">API</el-menu-item>
                </el-submenu>
              </el-submenu>
            </el-menu>
          </div>
          <el-button v-show="isRongeTong && isQingDao" :disabled="isEdit" style="margin-left: 5px" type="primary" class="can-operate" @click="updateRongeTongKManifestConfig">{{ $t('Message.UpdateVesselVoyNo') }}</el-button>
          <el-button v-show="isSeaHouseChannel || isWseChannel || isRongeTong" style="margin-left: 5px" type="primary" class="can-operate" @click="serviceInformation">{{ $t('SeaExport.OperationGuide') }}</el-button>
          <!-- 回执日志 -->
          <el-button
            v-show="!isSeaHouseChannel && !isWseChannel && !isRongeTong"
            no="8"
            style="vertical-align: bottom;"
            :disabled="isEdit"
            type="primary"
            @click="handleReceipt('receiptLog')"
          >{{ $t('SeaExport.ediFeedBackState') }}</el-button>
          <el-button
            v-if="isEdit"
            style="margin-left: 5px"
            type="primary"
            @click="synchronizationHandler"
          >{{ $t('SeaExport.Synchronization') }}</el-button>
          <el-button
            v-show="isSeaHouseChannel || isWseChannel || isRongeTong"
            v-permission="['button_SEBooking_ManifestModifyStatus']"
            :disabled="isEdit"
            style="margin-left: 5px"
            type="primary"
            @click="modifyReceiptStatus"
          >{{ $t('SeaExport.ModifyStatus') }}</el-button>
          <span style="margin-left: 10px">{{
            $t('SeaExport.IsOrNotSpelling')
          }}</span>
          <el-radio
            v-model="job.spelling"
            no="9"
            :disabled="addSpellingDisabled"
            :label="false"
          >{{ $t('SeaExport.No') }}</el-radio>
          <el-radio
            v-model="job.spelling"
            no="10"
            :disabled="addSpellingDisabled"
            :label="true"
          >{{ $t('SeaExport.Yes') }}</el-radio>
        </div>
      </div>
    </div>
    <div style="width: fit-content;min-width: 1540px">
      <div class="section">
        <div style="display: flex">
          <span class="title">{{ $t('SeaExport.manifestInformation') }}<i class="el-icon-warning icon-tip" @click="dialogVisible = true" /></span>
          <el-form inline label-position="left" style="margin-left: 20px; margin-top: 5px;">
            <el-form-item :label="$t('SeaExport.manifestChannel')">
              <el-radio-group v-model="localChannelDisplay" :disabled="!isEdit || isSent" @change="changeChannel">
                <el-radio :label="1">{{ $t('SeaExport.CargoWare') }}</el-radio>
                <el-radio :label="0">{{ $t('SeaExport.EDISend') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <!-- 舱单基本信息-->
        <booking-manifest-info
          v-if="Object.keys(job).length > 0"
          ref="bookingManifestBaseInfo"
          :manifest-infos.sync="manifestInfos"
          :manifest-info.sync="manifestInfo"
          :job="job"
          :is-edit="isEdit"
          :action="action"
          :context="context"
          :channel.sync="localChannel"
          @handleCarrier="handleCarrier()"
          @handleReceipt="handleReceipt('receiptLog')"
        />
      </div>
      <div class="section">
        <div style="display: flex">
          <span class="title">{{ $t('SeaExport.CustomerDeliveryInfo') }}</span>
          <el-button
            v-if="isEdit"
            style="margin-left: 5px;height: 28px;"
            type="primary"
            @click="copyCustomerShippingInformation"
          >{{ $t('CargoMsg.Cargo_CopyCustomerShippingInformation') }}</el-button>
        </div>
        <!--客户发运信息-->
        <booking-format-address
          ref="bookingFormatAddress"
          :job="job"
          :manifest-info.sync="manifestInfo"
          :manifest-infos.sync="manifestInfos"
          :is-editing="isEdit && !isCfmState"
          :is-add-spelling="job.spelling"
          :is-sea-house-channel.sync="isSeaHouseChannel"
          :is-wse-channel.sync="isWseChannel"
          :is-ronge-tong.sync="isRongeTong"
          :special-character-check="specialCharacterCheck"
          @cleanUpAll="cleanUpAll"
        />
      </div>
      <div class="section">
        <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
        <!--货物信息-->
        <booking-manifest-goods-info
          ref="bookingManifestGoodsInfo"
          :job="job"
          :manifest-info="manifestInfo"
          :is-edit="isEdit"
          :is-editing="isEdit && !isCfmState"
          :lcl-view="false"
          :is-or-not-display-so-no="true"
          :is-add-spelling="job.spelling"
          :is-sea-house-channel.sync="isSeaHouseChannel"
          :is-wse-channel.sync="isWseChannel"
          :is-ronge-tong.sync="isRongeTong"
          :channel.sync="localChannel"
          :show-combined-manifest="combinedManifest"
          :special-character-check="specialCharacterCheck"
          :vgm-required-input="vgmRequiredInput"
          :is-uppercase-by-config="isUppercaseByConfig"
          @soNoChange="soNoChangeHandler"
          @reload="reload"
        />
      </div>
      <div v-show="vgmRequiredInput" class="section">
        <span class="title">{{ $t('SeaExport.VgmInfo') }}</span>
        <booking-manifest-vgm-info
          :job="job"
          :manifest-info="manifestInfo"
          :is-sea-house-channel.sync="isSeaHouseChannel"
          :is-editing="isEdit && !isCfmState"
        />
      </div>
    </div>
    <!-- 复制弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="copyDialog.visible"
      :title="$t('Message.ManifestLink')"
      width="400px"
      :close-on-click-modal="false"
    >
      <span>{{ copyDialog.url }}</span>
      <div slot="footer" style="margin:0 auto;width:fit-content">
        <el-button
          no="12"
          type="primary"
          @click="handleClipboard(copyDialog.url, $event)"
        >{{ $t('SeaExport.Copy') }}</el-button>
        <el-button no="13" @click="copyDialog.visible = false">{{
          $t('common.btn.cancel')
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 在线舱单邀请邮件发送弹窗 -->
    <manifest-invitation-dialog
      :visible.sync="inviteDialog.visible"
      :invitation-type="inviteDialog.invitationType"
      :job="job"
      :manifest-info="manifestInfo"
    />
    <!-- 预配舱单弹窗 -->
    <pre-shipping-bill-dialog
      :visible.sync="preShippingBillDialog.visible"
      :title="preShippingBillDialog.title"
      @prePlanBookingToVgm="prePlanBookingToVgm"
      @reload="reload"
    />
    <!-- 舱单日志弹窗 -->
    <manifest-info-log-dialog
      :visible.sync="manifestInfoLogDialog.visible"
      :manifest-info-uuid="manifestInfo.uuid"
      :is-sea-house-channel="isSeaHouseChannel || isWseChannel || isRongeTong"
    />
    <!-- 回执日志弹窗 -->
    <edi-feed-back-state-title-dialog
      v-if="receiptLogDialog.visible"
      :visible.sync="receiptLogDialog.visible"
      :is-sea-house-channel="isSeaHouseChannel || isWseChannel || isRongeTong"
      :manifest-info-uuid="manifestInfo.uuid"
      :active-tab.sync="receiptLogDialog.activeTab"
      :job="job"
    />
    <!-- 通用选择弹窗 -->
    <dialog-selector
      :visible.sync="selectorDialog.visible"
      :title="selectorDialog.title"
      :row-data="selectorDialog.rowData"
      @selected="selectorDialogCallback"
    />
    <!-- api接口选择弹窗 -->
    <api-popup
      :visible.sync="apiPopup.visible"
      :title="apiPopup.title"
      :interface-type="apiPopup.interfaceType"
      :interface-array="apiPopup.interfaceArray"
      @selectedApi="selectedApiCallback"
    />
    <error-log-dialog
      :visible.sync="errorLogDialog.visible"
      :error-log="errorLogDialog.errorLog"
    />
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="right">
        <el-form-item :label="$t('SeaExport.SoNo')">
          <el-input />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ContainerNo')">
          <el-input />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.SealNo')">
          <el-input />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ContainerSize')">
          <el-input />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')">
          <el-input type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Marks')">
          <el-input type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="HSCode">
          <el-input type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Package')">
          <el-input />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Quantity')">
          <el-input />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Weight')">
          <el-input />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Cubage')">
          <el-input />
        </el-form-item>
        <el-form-item label="UN Code">
          <el-input />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.DangerousClass')">
          <el-input />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ediStatus')">
          <el-input :disabled="true" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="14" type="primary">{{ $t('common.btn.save') }}</el-button>
        <el-button no="15" @click="editDialog.visible = false">{{
          $t('common.btn.cancel')
        }}</el-button>
      </span>
    </el-dialog>
    <message-preview-dialog
      :visible.sync="messagePreviewDialog.visible"
      :params="messagePreviewDialog.params"
    />
    <!-- 海管家注意事项 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :title="$t('SeaExport.MattersNeedingAttention')"
      class="sea-house-dialog"
    >
      <div class="dialog-txt">
        <h6><i class="el-icon-warning icon-tip" />{{ $t('SeaExport.ExportReleaseNewRegulation') }}</h6>
        <p>{{ $t('SeaExport.ShanghaiAfterClearanceManifestContinuing') }}</p>
        <ul>
          <li>{{ $t('SeaExport.YangshanAreaNovember152021') }}</li>
          <li>{{ $t('SeaExport.WaigaoqiaoAreaNovember222021') }}</li>
        </ul>

        <h6><i class="el-icon-warning icon-tip" />{{ $t('SeaExport.GarbageCargoManifest') }}</h6>
        <p>{{ $t('SeaExport.N1ActuallyShippedIfGarbage') }}</p>
        <p>{{ $t('SeaExport.N2ManifestMustBeDeletion') }}</p>
        <p>{{ $t('SeaExport.N3YuanOnTheManifest') }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-checkbox v-model="notRemindNextTime" @change="hanldeRemindNext">{{ $t('SeaExport.DontRemindMeAgain') }}</el-checkbox>
        <el-button type="primary" class="can-operate" @click="dialogVisible = false">{{ $t('SeaExport.CloseSpace') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="updateWsTjDialog.visible"
      :title="$t('SeaExport.Prompt')"
      :close-on-click-modal="false"
      width="340px"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('Warehouse.ModifiedReason')" required>
          <el-select v-model="updateWsTjDialog.modifiedReason" no="checklistStatus" style="width:195px;" placeholder="">
            <el-option
              v-for="(item,index) in updateWsTjDialog.modifiedReasonList"
              :key="index"
              :label="item.code"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Warehouse.WsTjRemark')">
          <el-input v-model="updateWsTjDialog.remark" :placeholder="$t('Warehouse.ModifiedWsTjTips')" type="textarea" :row="5" style="width:195px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="toUpdateWsTj">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="updateWsTjDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="deleteWsTjDialog.visible"
      :title="$t('SeaExport.Prompt')"
      width="340px"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('Warehouse.WsTjReason')" required>
          <el-select v-model="deleteWsTjDialog.reason" no="checklistStatus" style="width:195px;" placeholder="">
            <el-option
              v-for="(item,index) in updateWsTjDialog.modifiedReasonList"
              :key="index"
              :label="item.code"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Warehouse.WsTjDelRemark')">
          <el-input v-model="deleteWsTjDialog.remark" :placeholder="$t('Warehouse.ModifiedWsTjTips')" type="textarea" :row="5" style="width:195px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="toDeleteWsTj">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="deleteWsTjDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 查看船代 -->
    <carrier-agent-data-grid
      v-show="carrierAgentDialog.visible"
      :visible.sync="carrierAgentDialog.visible"
      :row-data="[...manifestInfo]"
      :agent="carrierAgentDialog.agent"
      @close="carrierAgentDialog.visible=false"
    />
    <!-- 抄录收发通 -->
    <customer-shipping-information-copy-dialog
      v-if="copyShippingInfoDialog.visible"
      :job="job"
      :visible.sync="copyShippingInfoDialog.visible"
      :is-sea-house-channel="isSeaHouseChannel"
      @selected="selectAddressInfo"
    />
    <service-Information-Dialog-New
      :visible.sync="serviceInformationDialogNew.visible"
    />
    <choose-sea-house-del-dialog
      :manifest-goods="chooseSeaHouseDelDialog.manifestGoods"
      :manifest-info-uuid="manifestInfo.uuid"
      :is-wse-channel="isWseChannel"
      :is-ronge-tong="isRongeTong"
      :container-no-map="chooseSeaHouseDelDialog.containerNoMap"
      :visible.sync="chooseSeaHouseDelDialog.visible"
      @reload="reload"
    />
    <modify-manifest-status-dialog
      :visible.sync="modifyManifestStatusDialog.visible"
      :manifest-info="manifestInfo"
      :job-uuid="job.uuid"
      @reload="reload"
    />
    <!--校验弹框提示-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="checkDialog.visible"
      :title="checkDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="checkDialog.gridOptions"
        :column-defs="checkDialog.columnDefs"
        :row-data="checkDialog.rowData"
        :show-side-bar="false"
        style="height:350px"
        @gridReady="params=>{checkDialog.gridApi=params.api}"
      />
    </el-dialog>

    <!--修改船名航次弹窗-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="updateConfigDialog.visible"
      :title="updateConfigDialog.title"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-position="right" label-width="70px">
        <br><br>
        <el-form-item :label="this.$t('SeaExport.Vessel')" required>
          <el-input v-model="updateConfigDialog.vessel" />
        </el-form-item>
        <br>
        <el-form-item :label="this.$t('SeaExport.Voyage')" required>
          <el-input v-model="updateConfigDialog.voyage" />
        </el-form-item>
      </el-form>
      <br>
      <br>
      <div style="margin-top: 20px; text-align: center;">
        <el-button type="primary" @click="updateConfig">{{ $t('common.btn.confirmUpdate') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'

import preShippingBillDialog from '@/components/Cargo/Job/preShippingBillDialog'
import manifestInfoLogDialog from '@/components/Cargo/Job/manifestInfoLogDialog'
import ediFeedBackStateTitleDialog from '@/components/Cargo/Job/ediFeedBackStateTitleDialog'
import manifestInvitationDialog from '../manifestInvitationDialog'
import bookingFormatAddress from '../bookingFormatAddress'
import bookingManifestInfo from '../prePlanBookingJc/bookingManifestInfo'
import bookingManifestGoodsInfo from '../bookingManifestGoodsInfo'
import bookingManifestVgmInfo from '../bookingManifestVGMInfo'
import dialogSelector from '../../edi/dialogSelector'
import handleClipboard from '@/utils/clipboard'
import { ManifestCfmState } from '@/class/cargo/model/parameters/ManifestCfmState'
import { Job } from '@/class/model/booking/Job'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import { getLoading } from '@/utils/utilBaseElement'
import * as ediApi from '@/api/seaExport/edi'
import { getGridSelected } from '@/utils/agGrid'
import { getEDITemplate } from '@/api/sysManage/baseConfig/ediTemplate'
import { cache, cacheName } from '@/utils/cacheManager'
import { ModelMap } from '@/class/cargo/model/parameters/ModelMap'
import messagePreviewDialog from '@/views/cargo/v0/SeaExport/components/edi/messagePreviewDialog'
import {
  cancelSeaHousekeeper, deleteRongeTongKeeper,
  deleteWseKeeper,
  exportSinO56TemplateNb, sendRongeTongKeeper,
  sendWseKeeper, updateRongeTongKeeper,
  updateWseKeeper
} from '@/api/seaExport/manifestInfo'
import ApiPopup from '@/views/cargo/v0/SeaExport/components/edi/apiPopup'
import ErrorLogDialog from '@/views/cargo/v0/SeaExport/components/edi/errorLogDialog'
import StrUtils from '@/utils/StrUtils'
import { sendSeaHousekeeper, updateSeaHousekeeper, updateRongeTongManifestConfig } from '@/api/seaExport/manifestInfo'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { PrePlanBookingUtil } from '@/class/cargo/model/utils/PrePlanBookingUtil'
import { mergeArray } from '@/utils/commonUtil'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import CarrierAgentDataGrid from '@/views/cargo/v0/SeaExport/components/booking/prePlanBookingJc/carrierAgentDataGrid'
import CustomerShippingInformationCopyDialog
  from '@/views/cargo/v0/SeaExport/components/booking/prePlanBookingJc/CustomerShippingInformationCopyDialog'
import ChooseSeaHouseDelDialog
  from '@/views/cargo/v0/SeaExport/components/booking/prePlanBookingJc/chooseSeaHouseDelDialog'
import serviceInformationDialogNew from '@/components/Cargo/Job/serviceInformationDialogNew'
import $store from '@/store'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { BillAddress } from '@/class/model/mdm/BillAddress'
import { getConfigForCurrentTenant } from '@/api/sysManage/baseConfig/vasChannelConfig'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ModifyManifestStatusDialog from '@/components/Cargo/Job/modifyManifestStatusDialog'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'
import { sortByMultiField } from '@/utils'
import convertResToBlob from '@/utils/convertResToBlob'

export default {
  name: 'TabPrePlanBooking',
  components: {
    ModifyManifestStatusDialog,
    ChooseSeaHouseDelDialog,
    CustomerShippingInformationCopyDialog,
    CarrierAgentDataGrid,
    ErrorLogDialog,
    ApiPopup,
    preShippingBillDialog,
    manifestInfoLogDialog,
    ediFeedBackStateTitleDialog,
    manifestInvitationDialog,
    bookingFormatAddress,
    bookingManifestGoodsInfo,
    bookingManifestVgmInfo,
    dialogSelector,
    messagePreviewDialog,
    bookingManifestInfo,
    serviceInformationDialogNew
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      URL,
      ManifestCfmState,
      job: {},
      manifestInfo: new ManifestInfo().fillDefaultValue().getData(),
      manifestInfos: [],
      manifestType: 0,
      command1: this.$t('SeaExport.CopyLinkPromissoryNote'),
      command2: this.$t('SeaExport.InviteSupplementaryLinkPromissoryNote'),
      command3: this.$t('SeaExport.Original'),
      command4: this.$t('CargoMsg.Cargo_DownloadSource'),
      command5: this.$t('SeaExport.manifestQueryLog'),
      openBoolean: false,
      openClearBoolean: false,
      openVGMBoolean: false,
      combinedManifest: false,
      specialCharacterCheck: false,
      vgmRequiredInput: false, // 舱单VGM是否必录信息
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      copyDialog: {
        visible: false,
        url: ''
      },
      inviteDialog: {
        visible: false,
        invitationType: 0
      },
      preShippingBillDialog: {
        visible: false,
        title: ''
      },
      manifestInfoLogDialog: {
        visible: false
      },
      receiptLogDialog: {
        visible: false,
        activeTab: ''
      },
      // 操作指南
      serviceInformationDialogNew: {
        visible: false
      },
      // 通用选择弹窗
      selectorDialog: {
        visible: false,
        title: '',
        rowData: [],
        callback: () => {}
      },
      // api弹框
      apiPopup: {
        visible: false,
        title: '',
        state: '',
        interfaceType: 1,
        interfaceArray: ''
      },
      // 错误日志显示弹窗
      errorLogDialog: {
        visible: false,
        errorLog: ''
      },
      editDialog: {
        visible: false,
        title: ''
      },
      // 报文预览弹窗
      messagePreviewDialog: {
        visible: false,
        params: {}
      },
      // 查看船代弹窗
      carrierAgentDialog: {
        visible: false,
        agent: ''
      },
      // 抄录收发通
      copyShippingInfoDialog: {
        visible: false
      },
      // 选择删除货物
      chooseSeaHouseDelDialog: {
        visible: false,
        manifestGoods: [],
        sameContainerNo: []
      },
      updateWsTjDialog: {
        visible: false,
        remark: '',
        modifiedReason: '',
        modifiedReasonList: [
          { code: '货物漏装' },
          { code: '临时拉货' },
          { code: '错装、多装货物' },
          { code: '因疏忽而造成的舱单必填数据元差错' },
          { code: '更正因疏忽而造成的舱单选填数据元差错' },
          { code: '补充因疏忽而造成的舱单选填数据元差错' },
          { code: '更正因代理人等外部因素而造成的舱单必填数据元差错' },
          { code: '补充因代理人等外部因素而造成的舱单选填数据元差错' },
          { code: '补充因代理人等外部因素而造成的舱单选填数据元差错' },
          { code: '重复的舱单数据' },
          { code: '上一港口漏卸的货物' },
          { code: '在本监管场所错卸的货物' },
          { code: '货物在进入海关监管场所后失窃' },
          { code: '货物在进入海关监管场所后失踪' },
          { code: '根据案件处理结果修改' },
          { code: '其他原因（自定义）' }
        ]
      },
      deleteWsTjDialog: {
        visible: false,
        reason: '',
        remark: ''
      },
      globalVar: {},
      configMap: {},
      dialogVisible: false, // 海管家注意事项弹层
      notRemindNextTime: sessionStorage.getItem('notRemindNextTime') || false,
      ediStatusName: '',
      localChannel: 0, // 预配舱单通道
      vasChannel: 0, // 预配舱单配置通道
      isHZ: false,
      modifyManifestStatusDialog: {
        visible: false
      },
      checkDialog: {
        visible: false,
        title: this.$t('SeaExport.VerificationPrompt'),
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.Field'),
            field: 'field',
            width: 250
          },
          {
            headerName: this.$t('SeaExport.ErrorDescription'),
            field: 'errorDescription',
            width: 325
          }
        ],
        rowData: [],
        gridApi: null
      },
      updateConfigDialog: {
        visible: false,
        title: this.$t('Message.InputVesselVoyNo'),
        vessel: '',
        voyage: ''
      }
    }
  },
  computed: {
    isShangHai() {
      return this.manifestInfo.portOfLoading === 'CNSHA'
    },
    isQingDao() {
      return this.manifestInfo.portOfLoading === 'CNTAO'
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      // if (this.action === 'edit' && !this.notRemindNextTime) {
      //   this.dialogVisible = true
      // }
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    isCfmState() {
      return this.manifestInfo.cfmState === 4
    },
    btnCopyDisabled() {
      return !(this.readonly && !this.isCfmState)
    },
    btnInvitationDisabled() {
      return !(this.readonly && !this.isCfmState)
    },
    tempUnLockDisabled() {
      return !(this.action === 'look' && this.manifestInfo.cfmState === 4)
    },
    excelImportDisabled() {
      return !(this.action !== 'look' && !this.isCfmState)
    },
    popMenuDisabled() {
      return !(this.job.uuid && this.manifestInfo.uuid && this.readonly)
    },
    addSpellingDisabled() {
      return !(
        this.isEdit &&
        (this.manifestInfos.length === 0 || this.manifestInfos.length === 1)
      )
    },
    cfmStateText() {
      const cfmState = ManifestCfmState.getStateByCode(
        this.manifestInfo.cfmState
      ) || ManifestCfmState.CFM_STATE_NORMAL
      return this.isZh ? cfmState.chineseName : cfmState.englishName
    },
    user() {
      return this.context.user || {}
    },
    config() {
      return this.context.config
    },
    // 海管家客服QQ
    showSeaHouseTip() {
      return !!this.manifestInfo.manifestId
    },
    isSeaHouseChannel() { // 是否海管家通道
      return this.localChannel === 1 && !this.combinedManifest
    },
    isWseChannel() { // 是否未斯通道
      return this.localChannel === 2 && !this.combinedManifest
    },
    isRongeTong() { // 是否荣e通
      return this.localChannel === 3 && !this.combinedManifest
    },
    labelStyle() { // 是否海管家通道
      return this.isSeaHouseChannel ? 'required-label' : ''
    },
    isSent() {
      return PrePlanBookingUtil.isSent(this.manifestInfo)
    },
    localChannelDisplay: {
      get() {
        return this.localChannel === 0 ? 0 : 1
      },
      set(value) {
        if (value === 1) {
          this.vasChannel === 0 ? this.localChannel = SystemConstants.RONGE_TONG.code : this.localChannel = this.vasChannel
        } else {
          this.localChannel = 0
        }
        return value
      }
    }
  },
  watch: {
    // localChannel() {
    //   LocalStorageUtils.setConfiguration('prePlanBookingChannel', this.localChannel)
    // }
  },
  created() {
    this.isHZ = String(cache.config.get('ToExoSystem')) === 'HZ'
  },
  async mounted() {
    await cache.load(cacheName.CONFIG)
    this.configMap = cache.config
  },
  methods: {
    handleClipboard,
    async onShow(row, isRefresh) {
      this.$refs['bookingManifestGoodsInfo'].getSoNoList(row)
      if (!isRefresh) {
        this.$refs.bookingManifestBaseInfo.newCreateSync()
        return
      }
      this.job = row
      const { data: vasConfig } = await getConfigForCurrentTenant()
      if (vasConfig) {
        this.vasChannel = vasConfig.manifestChannel
      }
      if (this.job.uuid) {
        this.localChannel = (this.manifestInfo.channel === 1 || this.manifestInfo.channel === 2 || this.manifestInfo.channel === 3) ? this.manifestInfo.channel : 0
      } else {
        if (this.vasChannel !== 0) {
          this.localChannel = this.vasChannel
        }
      }
      if (row.uuid) {
        await new Job(row).getManifestInfo(true, true)
      }
      this.manifestInfos = row.manifestInfos || []
      if (this.manifestInfos.length > 0) {
        this.manifestInfos = sortByMultiField(this.manifestInfos, ['dateCreated'], false)
        this.manifestInfo = this.manifestInfos[0]
      } else {
        const manifestInfo = Object.assign(new ManifestInfo().fillDefaultValue().getData(), { jobUuid: row.uuid })
        await PrePlanBookingUtil.newCreateSyncWithJob(manifestInfo, row, false, [], this.localChannel)
        this.manifestInfo = manifestInfo
        this.manifestInfos.push(manifestInfo)
      }
      if (this.$refs.bookingFormatAddress) {
        this.$refs.bookingFormatAddress.toQuery(this.manifestInfos)
      }
      this.vgmRequiredInput = parseInt(this.config.get('ManifestVgmRequiredInput')) === 1
      this.openBoolean = parseInt(this.config.get('PreplanEDIApiOpen')) !== 0
      this.openClearBoolean = parseInt(this.config.get('ClearBookingEDIApiOpen')) !== 0
      this.openVGMBoolean = parseInt(this.config.get('VGMEDIApiOpen')) !== 0
      this.combinedManifest = Number(this.context.config.get('CombinedManifest')) === 1
      this.specialCharacterCheck = parseInt(this.config.get('SpecialCharacterCheck')) === 1
      this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    },
    // 服务指南
    serviceInformation() {
      this.serviceInformationDialogNew.visible = true
    },
    // 改配荣e通接口
    updateRongeTongKManifestConfig() {
      const canUpdateStates = ['21', '44', '45', '63']
      if (!(canUpdateStates.indexOf(this.manifestInfo.seaHouseState) > -1)) {
        this.$message.error(this.$t('Message.UpdateVesselVoyNoError'))
        return
      }
      this.updateConfigDialog.vessel = ''
      this.updateConfigDialog.voyage = ''
      this.updateConfigDialog.visible = true
    },
    clearPort() {
      const isSent = PrePlanBookingUtil.isSent(this.manifestInfo)
      if (!isSent) {
        this.manifestInfo.thirdPartyCarrier = ''
        this.manifestInfo.thirdPartyCarrierAgent = ''
      }
      if (this.isRongeTong) {
        // 提单件数
        if (this.manifestInfo.blNumber === 'ONE') {
          this.manifestInfo.blNumber = '1'
        } else if (this.manifestInfo.blNumber === 'TWO') {
          this.manifestInfo.blNumber = '2'
        } else if (this.manifestInfo.blNumber === 'THREE') {
          this.manifestInfo.blNumber = '3'
        }
      }
    },
    async getSubmitData() {
      const job = { ...this.job }
      this.$refs.bookingFormatAddress.checkModel('tabPrePlanBooking')
      this.$refs.bookingManifestGoodsInfo.checkModels('tabPrePlanBooking')
      let manifestInfos = null
      if (this.job.spelling && this.manifestInfos.length > 0) {
        manifestInfos = this.manifestInfos
      } else {
        manifestInfos = [this.manifestInfo]
      }
      for (const item of manifestInfos) {
        item.jobUuid = this.job.uuid
        this.toHalfWord(item)
      }
      this.manifestInfo.channel = this.localChannel
      await this.saveAddress(true)
      return { job, manifestInfos }
    },
    // 保存时将全角转成半角
    toHalfWord(manifestInfo) {
      if (manifestInfo.shipperShortCode) {
        manifestInfo.shipperShortCode = StrUtils.toHalfword(manifestInfo.shipperShortCode.trim())
      }
      if (manifestInfo.shipperEnterpriseCode) {
        manifestInfo.shipperEnterpriseCode = StrUtils.toHalfword(manifestInfo.shipperEnterpriseCode.trim())
      }
      if (manifestInfo.shipperEnterpriseName) {
        manifestInfo.shipperEnterpriseName = StrUtils.toHalfword(manifestInfo.shipperEnterpriseName.trim())
      }
      if (manifestInfo.shipperAddress) {
        manifestInfo.shipperAddress = StrUtils.toHalfword(manifestInfo.shipperAddress.trim())
      }
      if (manifestInfo.consigneeShortCode) {
        manifestInfo.consigneeShortCode = StrUtils.toHalfword(manifestInfo.consigneeShortCode.trim())
      }
      if (manifestInfo.consigneeEnterpriseCode) {
        manifestInfo.consigneeEnterpriseCode = StrUtils.toHalfword(manifestInfo.consigneeEnterpriseCode.trim())
      }
      if (manifestInfo.consigneeEnterpriseName) {
        manifestInfo.consigneeEnterpriseName = StrUtils.toHalfword(manifestInfo.consigneeEnterpriseName.trim())
      }
      if (manifestInfo.consigneeAddress) {
        manifestInfo.consigneeAddress = StrUtils.toHalfword(manifestInfo.consigneeAddress.trim())
      }
      if (manifestInfo.notifyShortCode) {
        manifestInfo.notifyShortCode = StrUtils.toHalfword(manifestInfo.notifyShortCode.trim())
      }
      if (manifestInfo.notifyEnterpriseCode) {
        manifestInfo.notifyEnterpriseCode = StrUtils.toHalfword(manifestInfo.notifyEnterpriseCode.trim())
      }
      if (manifestInfo.notifyEnterpriseName) {
        manifestInfo.notifyEnterpriseName = StrUtils.toHalfword(manifestInfo.notifyEnterpriseName.trim())
      }
      if (manifestInfo.notifyAddress) {
        manifestInfo.notifyAddress = StrUtils.toHalfword(manifestInfo.notifyAddress.trim())
      }
      const goods = manifestInfo.manifestGoods
      if (goods && goods.length > 0) {
        for (const good of goods) {
          if (good.cargoEnglishName) {
            good.cargoEnglishName = StrUtils.toHalfword(good.cargoEnglishName.trim())
          }
          if (good.mark) {
            good.mark = StrUtils.toHalfword(good.mark.trim())
          }
          if (good.hsCode) {
            good.hsCode = StrUtils.toHalfword(good.hsCode.trim())
          }
        }
      }
    },
    endTabHandler() {
      let manifestInfos = null
      if (this.job.spelling && this.manifestInfos.length > 0) {
        manifestInfos = this.manifestInfos
      } else {
        manifestInfos = [this.manifestInfo]
      }
      for (const item of manifestInfos) {
        item.jobUuid = this.job.uuid
      }
      this.job.manifestInfos = manifestInfos
      this.job.manifestInfoPage = true
    },
    async unLockManifestHandler() {
      if (!this.manifestInfo.uuid) {
        return
      }
      const manifestInfo = await new ManifestInfo(
        this.manifestInfo
      ).modifyCfmState(ManifestCfmState.CFM_STATE_SUBMIT.code)
      if (manifestInfo) {
        this.manifestInfo.cfmState = manifestInfo.cfmState
        this.manifestInfo.version = manifestInfo.version
        // 临时解锁时将同步状态置为0
        this.manifestInfo.syncState = 0
        if (this.isEdit) {
          manifestInfo.manifestGoods = this.manifestInfo.manifestGoods.filter(
            p => p.uuid
          )
          manifestInfo.manifestVGMs = this.manifestInfo.manifestVGMs.filter(
            p => p.uuid
          )
          this.$emit('syncData', { manifestInfo })
        }
      }
    },
    beforeUpload(file) {
      //  已发送情况下【Excel导入】 时，提示导入失败。
      const seaHouseState = this.manifestInfo.seaHouseState
      // 海管家-舱单状态 -1 未发送，1已发送未回执，21发送已回执成功，22发送回执失败，23发送回执退单，3、更新未回执，44、更新已回执成功，45、更新回执失败，5删除未回执，61、删除已回执成功，63、删除失败,，9退单
      if (!(!seaHouseState || seaHouseState === '-1' || seaHouseState === '61')) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ThePreAllocatedManifestHasBeenSentForThisTicketBusiness'))
        return false
      }
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      if ((Math.round(file.size * 100 / (1024 * 1024)) / 100) > 2) {
        this.$message.warning(this.$t('SeaExport.FileSizeCannotLargerThan2MB'))
        return false
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      PrePlanBookingUtil.saveImportData(response, this)
      this.$refs.bookingManifestBaseInfo.changeMbl()
      this.$refs.bookingFormatAddress.changeAll()
      // todo 增加埋点
      // LogStores.sendFunctionClickLogStoresByLabel(this.$t('SeaExport.BookingWorkspace_PrePlan_ImportExcel'))

      // CARGO-45907 【Excel导入】的是“大掌柜舱单”的格式时，需要自动选中“EDI发送”
      if (response && response.code === '0' && response.data) {
        if (response.data && response.data.importType === 4) {
          this.changeChannel(0)
        }
      }
    },
    importData(item) {
      const quantity = SEUtils.getQuantity(this.job)
      const manifestInfo = this.manifestInfo
      PrePlanBookingUtil.syncImportInfo(item, manifestInfo)
      let newNum = 0
      const soNoMap = {}
      if (this.isWseChannel || this.isRongeTong) {
        this.$refs.bookingManifestBaseInfo.init()
      }
      if (item.manifestGoods) {
        for (let i = item.manifestGoods.length - 1; i >= 0; --i) {
          if (item.manifestGoods[i].soNo && !soNoMap[item.manifestGoods[i].soNo]) {
            newNum += 1
            soNoMap[item.manifestGoods[i].soNo] = true
          }
        }
        this.$refs.bookingManifestGoodsInfo.importReload(manifestInfo.manifestGoods)
        this.$refs.bookingManifestGoodsInfo.calculation()
      }
      if (SEUtils.needTip(this.job, 'SONO') && newNum !== quantity) {
        this.$confirm(this.$t('CargoMsg.Cargo_SoNoChangeTips'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(async() => {
          this.soNoChangeHandler(newNum)
        })
      }
      if (this.isRongeTong) {
        this.manifestInfo.blNumber = 1
      }
    },
    async commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CopyLinkPromissoryNote'):
          this.copyDialog.url = await new ManifestInfo(
            this.manifestInfo
          ).getCfmManifestUrl()
          this.copyDialog.visible = true
          break
        case this.$t('SeaExport.CopyLinkPublic'):
          this.copyDialog.url = await new ManifestInfo(
            this.manifestInfo
          ).getCfmManifestShareUrl()
          this.copyDialog.visible = true
          break
        case this.$t('SeaExport.InviteSupplementaryLinkPromissoryNote'):
          this.inviteDialog.invitationType = 0
          this.inviteDialog.visible = true
          break
        case this.$t('SeaExport.InviteSupplementaryLinksPublic'):
          this.inviteDialog.invitationType = 1
          this.inviteDialog.visible = true
          break
        case this.$t('SeaExport.DownloadCWTemplate'):
          this.onDownloadTemplate()
          break
        case this.$t('SeaExport.DownloadSeaHouseTemplate'):
          this.onDownloadSeaHouseTemplate()
          break
        case this.$t('SeaExport.DownloadWseTemplate'):
          this.onDownloadWseTemplate()
          break
        case this.$t('SeaExport.DownloadWseTemplateSh'):
          this.onDownloadWseTemplateSh()
          break
        case this.$t('SeaExport.ExportSinO56TemplateNb'):
          this.onExportSinO56TemplateNb()
          break
        case this.$t('SeaExport.manifestQueryLog'):
          this.manifestInfoLogDialog.visible = true
          break
        case this.$t('SeaExport.ediFeedBackState'):
          this.receiptLogDialog.visible = true
          break
      }
    },
    // 确认
    // async cfmBtnClickHandlers() {
    //   if (!this.manifestInfo.uuid) {
    //     this.$message.warning(this.$t('SeaExport.ManifestDataIsEmpty'))
    //     return
    //   }
    //   if (
    //     !this.manifestInfo.manifestGoods ||
    //     this.manifestInfo.manifestGoods.length === 0
    //   ) {
    //     this.$message.warning(this.$t('SeaExport.CargoInformationIsEmpty'))
    //     return
    //   }
    //   if (
    //     this.vgmRequiredInput &&
    //     (!this.manifestInfo.manifestVGMs ||
    //       this.manifestInfo.manifestVGMs.length === 0)
    //   ) {
    //     this.$message.warning(this.$t('SeaExport.VGMIsEmpty'))
    //     return
    //   }
    //   confirmManifest({
    //     manifestInfoUuid: this.manifestInfo.uuid,
    //     branchId: this.$store.getters.currentOfficeId
    //   })
    //     .then(res => {
    //       this.$emit('reload')
    //       this.$message.success(this.$t('SeaExport.ManifestConfirmed'))
    //     })
    //     .catch()
    //     .finally()
    // },
    /**
     * 发送EDI
     */
    async ediSendHandler(index) {
      if (this.isEdit) return
      // 校验关单号

      if (index === 'API0' || index === 'API1') {
        const checkSoNo = await PrePlanBookingUtil.checkPrePlanBookingSoNo(this.manifestInfo, this.job, this)
        if (checkSoNo) {
          return
        }
      }
      // 未斯舱单 起运港为上海 货物类型为危险品 船代为  上海顺德 或者 上海华港 时 校验 “危险品联系人邮箱”、“危险品联系人传真”必填
      if (this.isWseChannel && this.isShangHai && this.manifestInfo.thirdPartyCargoType === 'D' &&
        (this.manifestInfo.thirdPartyCarrierAgent === 'SH_HUA_GANG' || this.manifestInfo.thirdPartyCarrierAgent === 'SH_SHUN_DE')) {
        if (!this.manifestInfo.manifestGoods || this.manifestInfo.manifestGoods.length === 0) {
          this.$message.warning(this.$t('SeaExport.CargoInformationIsEmpty'))
          return
        } else {
          for (const item of this.manifestInfo.manifestGoods) {
            if (!item.dgContactFax || !item.dgContactEmail) {
              this.$message.warning(this.$t('SeaExport.DangerousGoodsRequired'))
              return
            }
          }
        }
      }
      // 当货物类型选择“普通货物”但是填写了UN Code、危险品等级、危险品联系人、危险品联系人电话、危险品联系人邮箱 任意其中一个值，则点击发送时提示
      if ((this.isWseChannel && this.manifestInfo.thirdPartyCargoType === 'S') || (this.isSeaHouseChannel && this.manifestInfo.thirdPartyCargoType === 'GC')) {
        if (!this.manifestInfo.manifestGoods || this.manifestInfo.manifestGoods.length === 0) {
          this.$message.warning(this.$t('SeaExport.CargoInformationIsEmpty'))
          return
        } else {
          for (const item of this.manifestInfo.manifestGoods) {
            const errorList = []
            if (item.danUNNo) {
              errorList.push('UN Code')
            }
            if (item.danClassNo) {
              errorList.push(this.$t('SeaExport.DangerousClass'))
            }
            if (item.dngrContactUser) {
              errorList.push(this.$t('SeaExport.DangerousGoodsContact'))
            }
            if (item.dngrContactNumber) {
              errorList.push(this.$t('SeaExport.DangerousGoodsContactPhoneNumber'))
            }
            if (item.dgContactEmail) {
              errorList.push(this.$t('SpecialGoods.dgContactEmail'))
            }
            if (errorList.length > 0) {
              this.$message.error(this.$t('CargoMsg.Cargo_DangerousGoodsCheck', [errorList.join(',')]))
              return
            }
          }
        }
      }
      const type = this.manifestType
      this.ediStatusName = ''
      switch (type) {
        case 1:
          this.sendClearBookingEdi(index)
          break
        case 2:
          this.sendVgmEdi(index)
          break
        default:
          await this.sendPreShippingEdi(index)
          break
      }
    },

    /**
     * 清洁舱单
     */
    sendClearBookingEdi(lable) {
      switch (lable) {
        case 'API0':
        {
          this.ediStatusName = this.$t('SeaExport.OriginalCleaningManifest')
          this.bookingEDIApi('9')
          break
        }
        case 'FTP0':
        {
          this.ediStatusName = this.$t('SeaExport.OriginalCleaningManifest')
          this.sendClearEdi()
          break
        }
        case this.$t('SeaExport.Correction1'):
        {
          this.ediStatusName = this.$t('SeaExport.CorrectCleaningManifest')
          this.bookingEDIApi('5')
          break
        }
        default:
        {
          this.ediStatusName = this.$t('SeaExport.OriginalCleaningManifest')
          this.sendClearEdi()
          break
        }
      }
    },

    /**
     * 预配舱单
     */
    async sendPreShippingEdi(lable) {
      const validation = await PrePlanBookingUtil.validation(this.manifestInfo, this.job, 'whole')
      switch (lable) {
        case 'FTP1':
          this.ediStatusName = this.$t('SeaExport.OriginalPreAllocatedManifest')
          this.preShippingEdiAdd()
          break
        case 'FTP0':
          this.ediStatusName = this.$t('SeaExport.CorrectionOfPreAllocationManifest')
          this.preShippingEdiUpdate()
          break
        case this.$t('SeaExport.Delete'):
        case 'FTP2':
          this.ediStatusName = this.$t('SeaExport.DeletePreConfiguredManifest')
          this.preShippingEdiDelete()
          break
        // 原始
        case 'API0':
          if (this.isSeaHouseChannel && validation.name) {
            this.$confirm(`${validation.name}${this.$t('SeaExport.fields')}${validation.tabName}${this.$t('SeaExport.tab')}${validation.tabField}${this.$t('SeaExport.hint')}`, `${this.$t('SeaExport.Tips')}`, {
              confirmButtonText: `${this.$t('SeaExport.yes')}`,
              cancelButtonText: `${this.$t('SeaExport.no')}`,
              type: 'warning'
            }).then(() => {
              this.ediStatusName = this.$t('SeaExport.OriginalPreAllocatedManifest')
              this.bookingEDIApi('9')
            }).catch(() => {
            })
          } else {
            if (!this.manifestInfo.sailingDate && this.isQingDao) {
              this.$message.warning(this.$t('SeaExport.SailingDateEmpty'))
              return
            }
            this.ediStatusName = this.$t('SeaExport.OriginalPreAllocatedManifest')
            this.bookingEDIApi('9')
          }
          break
        // 更正
        case 'API1':
          if (this.isSeaHouseChannel && validation.name) {
            this.$confirm(`${validation.name}${this.$t('SeaExport.fields')}${validation.tabName}${this.$t('SeaExport.tab')}${validation.tabField}${this.$t('SeaExport.hint')}`, `${this.$t('SeaExport.Tips')}`, {
              confirmButtonText: `${this.$t('SeaExport.yes')}`,
              cancelButtonText: `${this.$t('SeaExport.no')}`,
              type: 'warning'
            }).then(() => {
              this.ediStatusName = this.$t('SeaExport.CorrectionOfPreAllocationManifest')
              this.bookingEDIApi('5')
            }).catch(() => {
            })
          } else {
            if (!this.manifestInfo.sailingDate && this.isQingDao) {
              this.$message.warning(this.$t('SeaExport.SailingDateEmpty'))
              return
            }
            this.ediStatusName = this.$t('SeaExport.CorrectionOfPreAllocationManifest')
            this.bookingEDIApi('5')
          }
          break
        // 删除
        case 'API2':
          if (!this.manifestInfo.sailingDate && this.isQingDao) {
            this.$message.warning(this.$t('SeaExport.SailingDateEmpty'))
            return
          }
          this.ediStatusName = this.$t('SeaExport.DeletePreConfiguredManifest')
          this.bookingEDIApi('99')
          break
        case 'API3':
          this.ediStatusName = this.$t('SeaExport.CancelPreConfiguredManifest')
          this.bookingEDIApi('-99')
          break
        default:
          this.ediStatusName = this.$t('SeaExport.OriginalPreAllocatedManifest')
          this.preShippingEdiAdd()
          break
      }
    },
    /**
     * api接口集合 原始  state 9：新增  5：修改 1：取消 99: 删除
     */
    bookingEDIApi(state) {
      const type = this.manifestType
      if (type && type === 1) {
        this.apiPopup.title = this.$t('SeaExport.CleanManifestAPI')
        this.apiPopup.interfaceArray = this.config.get('ClearBookingEDIApiOpen')
      } else if (type && type === 2) {
        this.apiPopup.title = 'VGMAPI'
        this.apiPopup.interfaceArray = this.config.get('VGMEDIApiOpen')
      } else {
        this.apiPopup.title = this.$t('SeaExport.PreConfiguredManifestAPI')
        if (this.isHZ) {
          this.apiPopup.interfaceArray = '5'
        } else {
          this.apiPopup.interfaceArray = this.config.get('PreplanEDIApiOpen')
        }
      }
      this.apiPopup.state = state
      this.apiPopup.interfaceType = 2
      // CARGO-42746 沃行代发发送接口不再让客户选择
      let data = null
      if (this.vasChannel && this.isSeaHouseChannel) {
        data = { 'id': '3', 'interface': this.$t('SeaExport.SeaHousekeeper'), 'remarks': this.$t('SeaExport.SeaHousekeeper') }
      } else if (this.vasChannel && this.isWseChannel) {
        data = { 'id': '4', 'interface': this.$t('SeaExport.Wse'), 'remarks': this.$t('SeaExport.Wse') }
      } else if (this.vasChannel && this.isRongeTong) {
        data = { 'id': '6', 'interface': '荣e通', 'remarks': '荣e通' }
      } else if (!this.vasChannel && (this.isWseChannel || this.isSeaHouseChannel || this.isRongeTong)) {
        data = { 'id': null }
      }
      if (data) {
        if (data.id) {
          this.selectedApiCallback(data)
        } else {
          this.$message.warning(this.$t('SeaExport.ServiceNotActivated'))
        }
        return
      }
      this.apiPopup.visible = true
    },
    /**
     * 预配舱单 原始
     */
    preShippingEdiAdd() {
      if (!this.manifestInfo) {
        this.$message.info(this.$t('SeaExport.TheEmptyPleaseRefreshAgain'))
      }
      this.preShippingHandler(this.$t('SeaExport.PreShippingBill'), 9)
    },
    /**
     * 修改
     */
    preShippingEdiUpdate() {
      if (!this.manifestInfo) {
        this.$message.info(this.$t('SeaExport.TheIsEmptyPleaseAgain'))
      }
      this.preShippingHandler(
        this.$t('SeaExport.CorrectionOfPreAllocatedManifest'),
        5
      )
    },
    /**
     * 删除
     */
    preShippingEdiDelete() {
      if (!this.manifestInfo) {
        this.$message.info(this.$t('SeaExport.PreConfiguredManifestIsEmpty'))
      }
      this.preShippingHandler(
        this.$t('SeaExport.PreConfiguredManifestDeletion'),
        4
      )
    },
    // 新增舱单回执查询
    handleReceipt(activeTab) {
      this.receiptLogDialog.activeTab = activeTab
      this.receiptLogDialog.visible = true
    },
    // 海管家注意事项不再提醒复选框事件
    hanldeRemindNext() {
      sessionStorage.setItem('notRemindNextTime', this.notRemindNextTime)
    },
    // 预配舱单处理
    preShippingHandler(title, editStatus) {
      const self = this
      self.globalVar.title = title
      self.globalVar.editStatus = editStatus
      self.globalVar.ediType = 26
      self.globalVar.ediTemplate = {}
      self.globalVar.ediTemplate.defaultFileType = '.txt'
      const manifestInfoKey = self.manifestInfo.uuid
      if (self.common().checkConfig('useEDITemplate', '1')) {
        self.common().showEDITemplateWin(manifestInfoKey)
      } else {
        const params = {
          jobUuids: [manifestInfoKey],
          editStatus: self.globalVar.editStatus
        }
        self.loading = getLoading()
        ediApi
          .getPreshippingManifestInfoEDI(params)
          .then(response => {
            self.commonCallback().onExportEDISuccess(response)
            if (editStatus === 5 || editStatus === 9) {
              this.saveAddress()
            }
          })
          .catch(err => {
            self.commonCallback().onExportEDIFail(err)
          })
          .finally(() => {
            self.loading.close()
          })
      }
    },
    /**
     * 清洁舱单
     */
    sendClearEdi() {
      const self = this
      if (!this.manifestInfo) {
        this.$message.info(this.$t('SeaExport.ThePleaseRefreshTheAgain'))
      }
      self.globalVar.title = this.$t('SeaExport.CleanShipping')
      self.globalVar.editStatus = 9
      self.globalVar.ediType = 27
      self.globalVar.ediTemplate = {}
      self.globalVar.ediTemplate.defaultFileType = '.txt'
      const manifestInfoKey = self.manifestInfo.uuid
      if (self.common().checkConfig('useEDITemplate', '1')) {
        self.common().showEDITemplateWin(manifestInfoKey)
      } else {
        const params = {
          jobUuids: [manifestInfoKey],
          editStatus: self.globalVar.editStatus
        }
        self.loading = getLoading()
        // todo 原cargo没有对应方法实现
        ediApi
          .getIFCSUMEDI(params)
          .then(response => {
            self.commonCallback().onExportEDISuccess(response)
          })
          .catch(err => {
            self.commonCallback().onExportEDIFail(err)
          })
          .finally(() => {
            self.loading.close()
          })
      }
    },
    /**
     * VGM
     */
    sendVgmEdi(lable) {
      const self = this
      if (!self.manifestInfo) {
        self.$message.info(this.$t('SeaExport.VGMRefreshThePageAgain'))
      }
      self.globalVar.ediType = 23
      let flag = true // 表示是否走原来的逻辑
      switch (lable) {
        case 'FTP0':// 原始 -FTP  对应原来的原始逻辑
        {
          self.globalVar.editStatus = 9
          self.globalVar.title = this.$t('SeaExport.VGMRaw')
          this.ediStatusName = this.$t('SeaExport.OriginalVGM')
          break
        }
        case 'API0':// 原始 - API
        {
          flag = false// 不走原来的逻辑
          this.ediStatusName = this.$t('SeaExport.OriginalVGM')
          this.bookingEDIApi('9')
          break
        }
        case 'FTP1':// 更正 -FTP 对应原来的更正逻辑
        {
          this.ediStatusName = this.$t('SeaExport.Correct') + 'VGM'
          self.globalVar.editStatus = 4
          self.globalVar.title = this.$t('SeaExport.VGMCorrection')
          break
        }
        case 'API1':// 更正 - API
        {
          this.ediStatusName = this.$t('SeaExport.Correct') + 'VGM'
          flag = false// 不走原来的逻辑
          this.bookingEDIApi('5')
          break
        }
        default:
        {
          this.ediStatusName = this.$t('SeaExport.Original') + 'VGM'
          self.globalVar.editStatus = 9
          self.globalVar.title = this.$t('SeaExport.VGMRaw')
          break
        }
      }
      if (!flag) {
        return
      }
      const manifestInfoKey = self.manifestInfo.uuid
      if (self.common().checkConfig('useEDITemplate', '1')) {
        self.common().showEDITemplateWin(manifestInfoKey)
      } else {
        const params = {
          jobUuid: manifestInfoKey,
          editStatus: self.globalVar.editStatus
        }
        self.loading = getLoading()
        // todo 原cargo没有对应方法实现
        ediApi
          .getVGMEDI(params)
          .then(response => {
            self.commonCallback().onExportEDISuccess(response)
          })
          .catch(err => {
            self.commonCallback().onExportEDIFail(err)
          })
          .finally(() => {
            self.loading.close()
          })
      }
    },
    // EDI公共方法
    common() {
      const self = this
      // configMap检测方法
      const checkConfig = (prop, targetValue) => {
        return (
          self.configMap !== null && self.configMap.get(prop) === targetValue
        )
      }
      // 获取selectedJobs & 拼接各类所需对象
      const getSelectedJobs = () => {
        if (!self.job || self.rowData.length < 1) {
          return
        }
        const selectedJobs = getGridSelected(self.gridOptions)
        self.globalVar.selectedJobs = selectedJobs
        if (selectedJobs && selectedJobs.length > 0) {
          self.globalVar.selectedJob = selectedJobs[0]
          self.globalVar.selectedJobKey = selectedJobs[0].uuid
          self.globalVar.selectedJobKeys = selectedJobs.map(item => item.uuid)
        }
      }
      // 显示EDI模板选择弹窗(selectorDialog)
      const showEDITemplateWin = uuid => {
        self.loading = getLoading()
        getEDITemplate({ templateType: this.globalVar.ediType })
          .then(result => {
            self.selectorDialog.title = self.globalVar.title
            self.selectorDialog.rowData = result.data
            self.selectorDialog.visible = true
          })
          .finally(() => {
            self.loading.close()
          })
      }
      // 弹出messagePreviewDialog
      const setEdiTabWindow = () => {
        self.messagePreviewDialog.params = {
          job: self.job,
          title: self.globalVar.title,
          ediType: self.globalVar.ediType,
          // ediFileName: self.globalVar,
          ediCollection: self.globalVar.ediDatas,
          ediTemplate: self.globalVar.ediTemplate,
          ediStatusName: self.ediStatusName
        }

        self.messagePreviewDialog.visible = true
      }
      // 判断SeaExportJob是否需要加载CargoDoc
      const needLoadCargoDoc = job => {
        return job.uuid && (job.cargoDoc == null || job.cargoDoc.length < 1)
      }
      // 判断SeaExportJob是否需要加载Containers
      const needLoadContainers = job => {
        return job.uuid && (job.containers == null || job.containers.length < 1)
      }
      // 判断数据选择情况
      const selectedJobItemCheck = () => {
        if (!self.globalVar.selectedJobKey) {
          self.$message.warning(this.$t('SeaExport.NoBusinessSelected'))
          return Promise.reject()
        }
      }

      return {
        checkConfig,
        getSelectedJobs,
        showEDITemplateWin,
        setEdiTabWindow,
        needLoadCargoDoc,
        needLoadContainers,
        selectedJobItemCheck
      }
    },
    // EDI公共回调方法
    commonCallback() {
      const self = this
      // edi导出成功回调方法
      const onExportEDISuccess = async response => {
        if (
          !response ||
          !response.data ||
          JSON.stringify(response.data) === '{}'
        ) {
          self.$message.info(this.$t('SeaExport.NoImportEDI'))
          return
        }
        self.globalVar.ediDatas = response.data
        if (this.job.spelling) { // 加拼
          this.job.manifestInfos = ''
          this.manifestInfos = await new Job(this.job).getManifestInfos(true, true)
        } else {
          const manifestInfo = new ManifestInfo(this.manifestInfo)
          this.manifestInfos = await manifestInfo.getManifestGoods()
        }

        self.common().setEdiTabWindow()
      }
      // edi导出失败回调方法
      const onExportEDIFail = dataMsg => {
        if (dataMsg instanceof Error) {
          return
        }
        const modelMap = ModelMap['ProperyLabelMap']
        const errorMsgArr = dataMsg ? dataMsg.split(';') : null
        let finalMessage = ''
        const suffixMsg = this.$t('SeaExport.ItIsEmpty') + '<br/>'
        if (errorMsgArr && errorMsgArr.length > 0) {
          errorMsgArr.forEach(errorMsg => {
            const modelField = errorMsg.split('.')
            if (modelField && modelField.length > 0) {
              const model = modelMap[modelField[0]]
              if (model) {
                finalMessage += model[modelField[1]] + suffixMsg
              }
            } else {
              finalMessage += errorMsg
            }
          })
        }
        if (!finalMessage) {
          finalMessage = dataMsg.replace(/\r\n/g, '<br/>')
        }
        self.$message.error({
          dangerouslyUseHTMLString: true,
          message: finalMessage
        })
      }
      return { onExportEDISuccess, onExportEDIFail }
    },
    selectorDialogCallback(row) {
      const self = this
      this.globalVar.ediTemplate = row
      this.globalVar.popMultiSegNumRulesType = 1
      const param = {}
      param.ediType = self.globalVar.ediType
      param.templateId = self.globalVar.ediTemplate.uuid
      param.jobUuids = [this.manifestInfo.uuid] // 这里传舱单的UUID
      param.editStatus = self.globalVar.editStatus
      param.ruleEDINos = []
      this.loading = getLoading()

      // 转移callback
      ediApi
        .getEDI(param)
        .then(result => self.commonCallback().onExportEDISuccess(result))
        .catch(message => self.commonCallback().onExportEDIFail(message))
        .finally(() => {
          self.loading.close()
        })
    },
    selectedApiCallback(row) {
      if (row) {
        const inteface = row['id'].toString()
        const type = this.manifestType
        let typeStr = 'PREMFT3'
        if (type === 1) {
          typeStr = 'CNCEDI'
        } else if (type === 2) {
          typeStr = 'VERMAS'
        }
        this.manifestInfo.sendChannel = 0
        if (inteface === '1') {
          if (this.apiPopup.state == '99') {
            this.preShippingEdiDelete()
            return
          }
          if (typeStr === 'PREMFT3') {
            if (!this.job.dispatchingPlace || !this.job.dispatchingPlace.trim()) {
              this.$message.warning(this.$t('SeaExport.TheBillOfLadingEmpty'))
              return
            }
            if (this.manifestInfo && this.manifestInfo.manifestGoods && this.manifestInfo.manifestGoods.length > 0) {
              for (const item of this.manifestInfo.manifestGoods) {
                if (!item.hsCode) {
                  this.$message.warning(this.$t('SeaExport.HscodeConfigurationInformationCannotEmpty'))
                  return
                }
                if (item.hsCode.length !== 6) {
                  this.$message.warning(this.$t('SeaExport.HscodeInformationMustBeDigits'))
                  return
                }
              }
            }
          }
          const param = {}
          param.jobUuid = this.job.uuid
          param.editStatus = parseInt(this.apiPopup.state)
          param.sendType = typeStr
          this.loading = getLoading()
          ediApi.getNingBoEportAPI(param).then(result => this.apiSuccess(result)).catch(message => {
            this.$message.error(message)
          }).finally(() => {
            this.loading.close()
          })
        } else if (inteface === '3') {
          this.manifestInfo.sendChannel = SeaExportConstants.SEND_CHANNEL_SEA_HOUSE.code
          // 新增海管家
          if (this.apiPopup.state === '9') {
            // if (this.manifestInfo.manifestId === '') {
            const param = this.formatSeaHouseParam()
            sendSeaHousekeeper(param).then(res => {
              if (res.code === '0') {
                this.$message.success(this.$t('SeaExport.SendingSucceeded'))
                this.saveAddress()
                this.$emit('prePlanBookingToVgm', this.manifestInfo)
                this.$emit('reload')
              }
            }).finally(() => {
              this.dialogVisible = false
              this.innerVisible = false
            })
            // } else {
            //   this.$message.warning(this.$t('SeaExport.TheTheReceiptLogInformation'))
            // }
          } else if (this.apiPopup.state === '5') {
            // if (this.manifestInfo.manifestId !== '') {
            // 校验是否勾选了货物信息
            // 勾选的货物信息是否未推送状态、
            const param = this.formatSeaHouseParam()
            updateSeaHousekeeper(param).then(res => {
              if (res.code === '0') {
                this.$message.success(this.$t('SeaExport.UpdateSucceeded'))
                this.saveAddress()
                this.$emit('reload')
              }
            })
            // } else {
            //   this.$message.info(this.$t('SeaExport.PleaseSuccessfullyIfNotFirst'))
            // }
          } else if (this.apiPopup.state === '99') {
            // 打开弹窗勾选需要删除的箱号
            if (!this.manifestInfo.manifestGoods || this.manifestInfo.manifestGoods.length === 0) {
              return
            }
            const list = this.manifestInfo.manifestGoods.sort((a, b) => {
              return a.containerNo.localeCompare(b.containerNo)
            })
            const map = {}
            const keyMap = {}
            for (const data of list) {
              if (!map.hasOwnProperty(data.containerNo)) {
                map[data.containerNo] = 0
                keyMap[data.containerNo] = []
              }
              map[data.containerNo] += 1
              keyMap[data.containerNo].push(data.uuid)
            }
            // 计算单元格合并行数
            const temp = {} // 判断箱号是否使用过
            for (const data of list) {
              data.rowspan = !temp.hasOwnProperty(data.containerNo) ? map[data.containerNo] : 0
              temp[data.containerNo] = true
            }
            this.chooseSeaHouseDelDialog.manifestGoods = list
            this.chooseSeaHouseDelDialog.containerNoMap = keyMap
            this.chooseSeaHouseDelDialog.visible = true
            // if (this.manifestInfo.manifestId !== '') {
            // } else {
            //   this.$message.info(this.$t('SeaExport.PleaseSuccessfullyIfNotFirst'))
            // }
          } else if (this.apiPopup.state === '-99') {
            const param = {
              uuid: this.manifestInfo.uuid
            }
            cancelSeaHousekeeper(param).then(res => {
              if (res.code === '0') {
                this.$message.success(this.$t('CargoMsg.Cargo_RevokedSuccessfully'))
                this.$emit('reload')
              }
            })
          }
        } else if (inteface === '4') {
          this.manifestInfo.sendChannel = SeaExportConstants.SEND_CHANNEL_WSE.code
          // 未斯舱单
          // 新增
          if (this.apiPopup.state === '9') {
            const param = this.formatSeaHouseParam()
            // param.officeId = $store.getters.currentOfficeId
            this.loading = getLoading()
            sendWseKeeper(param).then(res => {
              if (res.code === '0') {
                this.$message.success(this.$t('SeaExport.SendingSucceeded'))
                this.$emit('prePlanBookingToVgm', this.manifestInfo)
                this.saveAddress()
                this.$emit('reload')
              }
            }).finally(() => {
              this.loading.close()
              this.dialogVisible = false
              this.innerVisible = false
            })
          } else if (this.apiPopup.state === '5') {
            if (this.isShangHai) {
              const param = this.formatSeaHouseParam()
              param.officeId = $store.getters.currentOfficeId
              this.loading = getLoading()
              updateWseKeeper(param).then(res => {
                if (res.code === '0') {
                  this.$message.success(this.$t('SeaExport.UpdateSucceeded'))
                  this.saveAddress()
                  this.$emit('reload')
                }
              }).finally(() => {
                this.loading.close()
                this.updateWsTjDialog.visible = false
              })
            } else {
              this.updateWsTjDialog.remark = ''
              this.updateWsTjDialog.modifiedReason = ''
              this.updateWsTjDialog.visible = true
            }
          } else if (this.apiPopup.state === '99') {
            if (this.isShangHai) {
              // 打开弹窗勾选需要删除的箱号
              if (!this.manifestInfo.manifestGoods || this.manifestInfo.manifestGoods.length === 0) {
                return
              }
              const list = this.manifestInfo.manifestGoods.sort((a, b) => {
                return a.containerNo.localeCompare(b.containerNo)
              })
              const map = {}
              const keyMap = {}
              for (const data of list) {
                if (!map.hasOwnProperty(data.containerNo)) {
                  map[data.containerNo] = 0
                  keyMap[data.containerNo] = []
                }
                map[data.containerNo] += 1
                keyMap[data.containerNo].push(data.uuid)
              }
              // 计算单元格合并行数
              const temp = {} // 判断箱号是否使用过
              for (const data of list) {
                data.rowspan = !temp.hasOwnProperty(data.containerNo) ? map[data.containerNo] : 0
                temp[data.containerNo] = true
              }
              this.chooseSeaHouseDelDialog.manifestGoods = list
              this.chooseSeaHouseDelDialog.containerNoMap = keyMap
              this.chooseSeaHouseDelDialog.visible = true
            } else {
              this.deleteWsTjDialog.reason = ''
              this.deleteWsTjDialog.visible = true
            }
          }
        } else if (inteface === '5') {
          const loading = getLoading4Cxt()
          const param = { ...this.manifestInfo }
          param.jobUuid = this.job.uuid
          param.jobNo = this.job.jobNo
          param.mbl = this.job.mbl
          param.sendType = EdiType.SHIPPING_EDI_TYPE.code // 预配舱单
          param.manifestInfoUuid = this.manifestInfo.uuid
          ediApi.getMingShenBookingAPI(param).then(result => {
            if (result.data.success) {
              this.$message.success(this.$t('Message.SuccessfullySent'))
            } else {
              this.$message.error(result.data.message)
            }
          }).catch(message => {
            this.$message.error(message)
          }).finally(() => {
            loading.close()
          })
        } else if (inteface === '6') {
          this.manifestInfo.sendChannel = SeaExportConstants.SEND_CHANNEL_RONGE_TONG.code
          // 荣e通舱单
          // 新增
          if (this.apiPopup.state === '9') {
            const param = this.formatSeaHouseParam()
            this.loading = getLoading()
            const checkList = PrePlanBookingUtil.rongeTongSendCheck(this.manifestInfo, this.manifestInfo.manifestGoods, this)
            if (checkList && checkList.length > 0) {
              this.checkDialog.visible = true
              this.checkDialog.rowData = checkList
              this.loading.close()
              return
            }
            sendRongeTongKeeper(param).then(res => {
              if (res.ok) {
                this.$message.success(this.$t('SeaExport.SendingSucceeded'))
                this.$emit('prePlanBookingToVgm', this.manifestInfo)
                this.saveAddress()
                this.$emit('reload')
              } else {
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.loading.close()
            })
          } else if (this.apiPopup.state === '5') {
            const param = this.formatSeaHouseParam()
            param.officeId = $store.getters.currentOfficeId
            this.loading = getLoading()
            updateRongeTongKeeper(param).then(res => {
              if (res.ok) {
                this.$message.success(this.$t('SeaExport.SendingSucceeded'))
                this.$emit('prePlanBookingToVgm', this.manifestInfo)
                this.saveAddress()
                this.$emit('reload')
              } else {
                this.$message.error(res.message)
              }
            }).finally(() => {
              this.loading.close()
              this.updateWsTjDialog.visible = false
            })
          } else if (this.apiPopup.state === '99') {
            // 打开弹窗勾选需要删除的箱号
            if (!this.manifestInfo.manifestGoods || this.manifestInfo.manifestGoods.length === 0) {
              this.$message.error(this.$t('Message.NoDelete'))
              return
            }
            let manifestGoods = this.manifestInfo.manifestGoods
            // 需要过滤掉删单成功的数据 （发送已回执成功、更新已回执成功、更新回执失败、删除失败、非原始的退单） 只有这些才能显示删除列表
            manifestGoods = manifestGoods.filter(p => (p.seaHouseState === '21' || p.seaHouseState === '44' || p.seaHouseState === '45' || p.seaHouseState === '63' || p.seaHouseState === '9'))
            if (!manifestGoods || manifestGoods.length === 0) {
              this.$message.error(this.$t('Message.NoDelete'))
              return
            }
            const list = manifestGoods.sort((a, b) => {
              return a.containerNo.localeCompare(b.containerNo)
            })
            const map = {}
            const keyMap = {}
            for (const data of list) {
              if (!map.hasOwnProperty(data.containerNo)) {
                map[data.containerNo] = 0
                keyMap[data.containerNo] = []
              }
              map[data.containerNo] += 1
              keyMap[data.containerNo].push(data.uuid)
            }
            // 计算单元格合并行数
            const temp = {} // 判断箱号是否使用过
            for (const data of list) {
              data.rowspan = !temp.hasOwnProperty(data.containerNo) ? map[data.containerNo] : 0
              temp[data.containerNo] = true
            }
            this.chooseSeaHouseDelDialog.manifestGoods = list
            this.chooseSeaHouseDelDialog.containerNoMap = keyMap
            this.chooseSeaHouseDelDialog.visible = true
          }
        }
      }
    },
    toUpdateWsTj() {
      if (!this.updateWsTjDialog.modifiedReason) {
        this.$message.warning(this.$t('SeaExport.WseModifyReasonNotEmpty'))
        return
      }
      if (this.updateWsTjDialog.modifiedReason === '其他原因（自定义）' && !this.updateWsTjDialog.remark.replace(/\s/g, '')) {
        this.$message.warning(this.$t('SeaExport.WseModifyRemarkNotEmpty'))
        return
      }
      const param = this.formatSeaHouseParam()
      param.officeId = $store.getters.currentOfficeId
      param.modifiedReason = this.updateWsTjDialog.modifiedReason
      param.remark = this.updateWsTjDialog.remark
      this.loading = getLoading()
      updateWseKeeper(param).then(res => {
        if (res.code === '0') {
          this.$message.success(this.$t('SeaExport.UpdateSucceeded'))
          this.saveAddress()
          this.$emit('reload')
        }
      }).finally(() => {
        this.loading.close()
        this.updateWsTjDialog.visible = false
      })
    },
    toDeleteWsTj() {
      if (!this.deleteWsTjDialog.reason) {
        this.$message.warning(this.$t('SeaExport.WseDeleteReasonNotEmpty'))
        return
      }
      if (this.deleteWsTjDialog.reason === '其他原因（自定义）' && !this.deleteWsTjDialog.remark.replace(/\s/g, '')) {
        this.$message.warning(this.$t('SeaExport.WseDeleteRemarkNotEmpty'))
        return
      }
      const param = this.formatSeaHouseParam()
      if (this.deleteWsTjDialog.reason === '其他原因（自定义）') {
        param.reason = this.deleteWsTjDialog.remark
      } else {
        param.reason = this.deleteWsTjDialog.reason
      }
      param.officeId = $store.getters.currentOfficeId
      this.loading = getLoading()
      if (this.isRongeTong) {
        deleteRongeTongKeeper(param).then(res => {
          if (res.code === '0') {
            this.$message.success(this.$t('SeaExport.UpdateSucceeded'))
            this.$emit('reload')
          }
        }).finally(() => {
          this.loading.close()
          this.deleteWsTjDialog.visible = false
        })
      } else {
        deleteWseKeeper(param).then(res => {
          if (res.code === '0') {
            this.$message.success(this.$t('SeaExport.UpdateSucceeded'))
            this.$emit('reload')
          }
        }).finally(() => {
          this.loading.close()
          this.deleteWsTjDialog.visible = false
        })
      }
    },
    formatSeaHouseParam() {
      const goodInfos = this.$refs['bookingManifestGoodsInfo'].loadChooseData()
      const goodInfoUuids = []
      if (goodInfos && goodInfos.length > 0) {
        for (const goodInfo of goodInfos) {
          goodInfoUuids.push(goodInfo.uuid)
        }
      }
      const param = {
        uuid: this.manifestInfo.uuid
      }
      if (goodInfoUuids.length > 0) {
        param['updateSeaHouseGoodInfoKeys'] = goodInfoUuids
      }
      return param
    },
    /**
     * 成功
     */
    apiSuccess(event) {
      const o = event.data
      if (o) {
        const success = o.isSuccess
        if (success) {
          this.$message.success(this.$t('SeaExport.RequestSuccessful'))
          this.saveAddress()
        } else {
          const text = o.text.toString()
          const textStr = text.substring(0, text.length - 5) + text.substring(text.length - 5, text.length).replace(';', '')
          this.errorLogDialog.errorLog = textStr
          this.errorLogDialog.visible = true
        }
      }
    },
    // 组装打印参数
    getPrintData() {
      if (this.manifestInfo && this.manifestInfo.uuid) {
        const params = {}
        // params.MANIFEST_INFO_UUID = this.manifestInfo.uuid
        PrintTemplateUtil.buildPrintDataByManifestInfo(this.manifestInfo, params)
        params.category = 'MANIFESTINFO'
        params.ctx = new ManifestInfo(this.manifestInfo)
        return params
      }
    },
    soNoChangeHandler(quantity) {
      let isFlag = false
      const charges = []
      for (const charge of this.job.charges) {
        // 更新箱数的费用
        if (SEUtils.checkAdjust(charge) && charge.measure === 'SONO') {
          charge.quantity = quantity
          // CARGO-4980 单价是否含税
          if (charge.unitPriceIncludeTax) {
            ChargeUtils.calculateTaxAmount(charge, charge.quantity * charge.unitRate, charge.taxRate)
          } else {
            ChargeUtils.calculateTax(charge, charge.quantity * charge.unitRate, charge.taxRate)
          }
          charges.push(charge)
          if (!isFlag) isFlag = true
        }
      }
      if (isFlag && charges.length > 0) {
        this.context.modifiedData.charges = this.context.modifiedData.charges || []
        mergeArray(this.context.modifiedData.charges, charges) // 只记住修改过的数据
      }
      this.context.reloadCharge = true
    },
    linkQQ() {
      window.open('https://wpa1.qq.com/PGnQpUyj?_type=wpa&qidian=true')
    },
    changeChannel(value) {
      if (value === 1) {
        // 如果设置了增值服务配置通道，则按设置的来，未设置则默认荣e通通道
        this.localChannel = (this.vasChannel !== 0) ? this.vasChannel : SystemConstants.RONGE_TONG.code
        // 切换预配舱单通道以后，需要重新初始化货物信息中的列表下拉框数据
        if (this.$refs['bookingManifestGoodsInfo']) {
          this.$refs['bookingManifestGoodsInfo'].initParams()
        }
      } else if (value === 0) {
        this.localChannel = 0
      }
      this.clearPort()
    },
    onDownloadTemplate() {
      const fileName = 'manifestTemplate.xlsx'
      ExportUtils.downloadTemplateFile(fileName, 'booking')
    },
    onDownloadSeaHouseTemplate() {
      ExportUtils.downloadTemplateFile('SeaHouse-ManifestTemplate.xlsx', 'booking')
    },
    onDownloadWseTemplate() {
      if (this.isRongeTong) {
        ExportUtils.downloadTemplateFile('RongeTong-Qd-ManifestTemplate.xlsx', 'booking')
      } else {
        ExportUtils.downloadTemplateFile('Wse-Qd-ManifestTemplate.xlsx', 'booking')
      }
    },
    onDownloadWseTemplateSh() {
      if (this.isRongeTong) {
        ExportUtils.downloadTemplateFile('RongeTong-Sh-ManifestTemplate.xlsx', 'booking')
      } else {
        ExportUtils.downloadTemplateFile('Wse-Sh-ManifestTemplate.xlsx', 'booking')
      }
    },
    onExportSinO56TemplateNb() {
      const filter = {
        jobUuid: this.job.uuid,
        manifestInfoUuid: this.manifestInfo.uuid,
        templateName: 'SinO56-Nb-Template.xlsx'
      }
      const loading = getLoading4Cxt(this)
      exportSinO56TemplateNb(filter).then(res => {
        convertResToBlob(res)
        this.$message.success(this.$t('Message.RequestSucceededExporting'))
        loading.close()
      }).catch((err) => {
        this.$message.error(err)
        loading.close()
      })
    },
    async showShipGenerations() {
      const { bargeVessel, bargeVoyage, thirdPartyCarrier, mblNo } = this.manifestInfo
      if (!bargeVessel) {
        this.$message.error(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('SeaExport.Vessel'))
        return
      }
      if (!bargeVoyage) {
        this.$message.error(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('SeaExport.Voyage'))
        return
      }
      if (!thirdPartyCarrier) {
        this.$message.error(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('SeaExport.ShippingCompany'))
        return
      }
      if (this.isRongeTong) {
        if (!this.manifestInfo.portOfLoading) {
          this.$message.error(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('SeaExport.PortOfLoadingAI'))
          return
        }
        if (!mblNo) {
          this.$message.error(this.$t('CargoMsg.Cargo_PlsInput') + 'MB/L NO')
          return
        }
      } else {
        if (this.isQingDao) {
          this.$message.error(this.$t('SeaExport.SupportsShanghaiPortShipAgent'))
          return
        }
      }
      let agent = null
      if (this.isSeaHouseChannel) {
        agent = await PrePlanBookingUtil.getSeaHouseShipCompanyAgentByApi(thirdPartyCarrier, bargeVessel, bargeVoyage)
      } else if (this.isWseChannel) {
        agent = await PrePlanBookingUtil.getWseShipCompanyAgentByApi(thirdPartyCarrier, bargeVessel, bargeVoyage)
      } else if (this.isRongeTong) {
        agent = await PrePlanBookingUtil.getRongeTongShipCompanyAgentByApi(this.manifestInfo.portOfLoading, thirdPartyCarrier, bargeVessel, bargeVoyage, mblNo)
      }
      this.carrierAgentDialog.agent = agent
      this.carrierAgentDialog.visible = true
    },
    async synchronizationHandler() {
      await PrePlanBookingUtil.newCreateSyncWithJob(this.manifestInfo, this.job, true, [], this.localChannel)
    },
    /**
     * 抄录收发通
     * @returns {Promise<void>}
     */
    async copyCustomerShippingInformation() {
      this.copyShippingInfoDialog.visible = true
    },
    /**
     * 抄录收发通回调
     * @param data
     */
    selectAddressInfo(data, syncKeys) {
      PrePlanBookingUtil.syncCustomerShippingInformation(this.manifestInfo, data, syncKeys)
      // 清除收发通提示
      this.$refs.bookingFormatAddress.changeTip(syncKeys)
    },
    cleanUpAll() {
      setTimeout(() => {
        this.$refs.bookingManifestBaseInfo.cleanUpAll()
      }, 50)
    },
    prePlanBookingToVgm(manifestInfo) {
      this.$emit('prePlanBookingToVgm', manifestInfo)
    },
    handleCarrier() {
      this.$nextTick(() => {
        this.$refs.bookingManifestGoodsInfo.changeThirdPartyCarrier()
      })
    },
    reload() {
      this.$emit('reload')
    },
    /**
     * 发送预配舱单时，保存收发通信息
     * */
    async saveAddress(isSave) {
      if (isSave) {
        // 如果是业务保存，则判断下是不是EDI发送，如果不是则不保存收发通
        if (this.localChannelDisplay !== 0) {
          return
        }
      } else {
        // 如果不是业务保存（是发送），则判断下是不是EDI发送，如果是则不保存收发通
        if (this.localChannelDisplay === 0) {
          return
        }
      }
      if (parseInt(this.context.config.get('syncMailingAddress')) !== 1) {
        return
      }
      const manifestInfo = this.manifestInfo
      if (manifestInfo === null) {
        return
      }
      const job = this.job
      if (!job) { return }
      let partnerId = 0
      if (this.job.cargoSource === 'SC') {
        partnerId = this.job.customerId
      } else if (this.job.cargoSource === 'NC') {
        partnerId = this.job.designationAgent
      }
      if (partnerId === 0) {
        return
      }
      const addr = new BillAddress().fillDefaultValue()
      addr.billHistoryType = 0
      addr.partnerId = partnerId
      addr.pod = manifestInfo.portOfDestination
      addr.lob = job.lob
      addr.officeId = $store.getters.currentOfficeId
      addr.shipperCode = manifestInfo.shipperCode
      addr.consigneeCode = manifestInfo.consigneeCode
      addr.notifyCode = manifestInfo.notifyCode

      addr.shipperLine1 = manifestInfo.shipperLine1
      addr.consigneeLine1 = manifestInfo.consigneeLine1
      addr.notifyLine1 = manifestInfo.notifyLine1

      addr.shipperShortCode = manifestInfo.shipperShortCode
      addr.shipperEnterpriseCode = manifestInfo.shipperEnterpriseCode
      addr.shipperEnterpriseName = manifestInfo.shipperEnterpriseName
      addr.shipperAddress = manifestInfo.shipperAddress
      addr.shipperContactsType = manifestInfo.shipperContactsType
      addr.shipperContacts = manifestInfo.shipperContacts
      addr.shipperCityName = manifestInfo.shipperCityName
      addr.shipperProvinceCode = manifestInfo.shipperProvinceCode
      addr.shipperProvinceName = manifestInfo.shipperProvinceName
      addr.shipperZipCode = manifestInfo.shipperZipCode
      addr.shipperCountryCode = manifestInfo.shipperCountryCode
      addr.shipperAeoEnterpriseCode = manifestInfo.shipperAeoEnterpriseCode
      addr.consigneeShortCode = manifestInfo.consigneeShortCode
      addr.consigneeEnterpriseCode = manifestInfo.consigneeEnterpriseCode
      addr.consigneeEnterpriseName = manifestInfo.consigneeEnterpriseName
      addr.consigneeAddress = manifestInfo.consigneeAddress
      addr.consigneeContactsType = manifestInfo.consigneeContactsType
      addr.consigneeContacts = manifestInfo.consigneeContacts
      addr.consigneeCityName = manifestInfo.consigneeCityName
      addr.consigneeProvinceCode = manifestInfo.consigneeProvinceCode
      addr.consigneeProvinceName = manifestInfo.consigneeProvinceName
      addr.consigneeZipCode = manifestInfo.consigneeZipCode
      addr.consigneeCountryCode = manifestInfo.consigneeCountryCode
      addr.consigneeAeoEnterpriseCode = manifestInfo.consigneeAeoEnterpriseCode
      addr.consigneeSpecificContacts = manifestInfo.consigneeSpecificContacts
      addr.consigneeSpecificContactsName = manifestInfo.consigneeSpecificContactsName
      addr.consigneeSpecificContactsType = manifestInfo.consigneeSpecificContactsType
      addr.notifyShortCode = manifestInfo.notifyShortCode
      addr.notifyEnterpriseCode = manifestInfo.notifyEnterpriseCode
      addr.notifyEnterpriseName = manifestInfo.notifyEnterpriseName
      addr.notifyAddress = manifestInfo.notifyAddress
      addr.notifyContactsType = manifestInfo.notifyContactsType
      addr.notifyContacts = manifestInfo.notifyContacts
      addr.notifyCityName = manifestInfo.notifyCityName
      addr.notifyProvinceCode = manifestInfo.notifyProvinceCode
      addr.notifyProvinceName = manifestInfo.notifyProvinceName
      addr.notifyZipCode = manifestInfo.notifyZipCode
      addr.notifyCountryCode = manifestInfo.notifyCountryCode
      addr.notifyAeoEnterpriseCode = manifestInfo.notifyAeoEnterpriseCode
      const data = addr.getData()
      data.preConfigured = true
      BillAddress.checkBillAddress(data).then()
    },
    modifyReceiptStatus() {
      this.modifyManifestStatusDialog.visible = true
    },
    /**
     * 调用荣e通 青岛舱单改配接口
     */
    async updateConfig() {
      if (!this.updateConfigDialog.vessel) {
        this.$message.error(this.$t('SeaExport.ShipNameCannotBeEmpty'))
        return
      }
      if (!this.updateConfigDialog.voyage) {
        this.$message.error(this.$t('SeaExport.VoyageCannotBeEmpty'))
        return
      }
      if (!this.manifestInfo.mblNo) {
        this.$message.error(this.$t('SeaExport.MBNOCannotBeEmpty'))
        return
      }
      const loading = getLoading()
      const param = {
        vessel: this.updateConfigDialog.vessel,
        voyNo: this.updateConfigDialog.voyage,
        masterBillNo: this.manifestInfo.mblNo,
        manifestInfoUuId: this.manifestInfo.uuid
      }
      updateRongeTongManifestConfig(param).then(async res => {
        if (res.ok) {
          this.$message.success(this.$t('Message.EditedSuccessfully'))
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        loading.close()
        this.updateConfigDialog.visible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#tab-pre-plan-booking{
  .section{
    .title{
      line-height: 24px;
      margin: 5px 0 10px 0;
      .icon-tip{
        vertical-align: middle;
        margin-bottom: 4px;
        margin-left: 2px;
        color: orange;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }
}
.sea-house-dialog{
  .dialog-txt{
    padding: 0 20px 10px 20px;
    h6{
      line-height: 20px;
      margin: 20px 0 10px 0;
      color: #333;
      font-size: 16px;
      font-weight: normal;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      i{
        margin-right: 8px;
        color: orange;
        font-size: 20px;
      }
    }
    p{
      margin: 5px 0;
      line-height: 20px;
      padding-left: 25px;
      color: #666;
      font-size: 14px;
    }
    ul{
      margin: 0;
      li{
        color: #666;
        line-height: 20px;
        font-size: 14px;
        list-style: disc;
        &::marker{
          font-size: 20px;
        }
      }
    }
  }
  .el-checkbox{
    margin-right: 20px;
  }
}
.sea-house-tip{
  position: fixed;
  right: 1%;
  top: 40%;
  width: 60px;
  height: 60px;
  cursor: pointer;
  img{
    width: 100%;
  }
}
/deep/ .required-label .el-form-item__label {
  color: #1F75D5 !important;
}
</style>
